var _path, _rect, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHair0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 640",
    x: "0px",
    y: "0px",
    fill: "#7ea3d8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.878,224a7.992,7.992,0,0,1-1.054,3.969L34.529,277.485l17.787,11.859a8,8,0,0,1,3.407,5.087l10.855,54.275A24.065,24.065,0,0,0,90.112,368h13.766c1.535-.027,40.167-.269,60.131,19.39a38.9,38.9,0,0,1,11.869,28.586c.085,27.86.111,52.045.119,64.024h31.881V288a8,8,0,0,1,8-8H216c13.009,0,24-18.317,24-40s-10.991-40-24-40h-.122c-10.754,0-16.786,11.462-16.844,11.578a8,8,0,0,1-12.241,2.6L63.878,112.952Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 384,
    width: 112,
    height: 48
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M480,360a24.027,24.027,0,0,0-24-24H296a24.027,24.027,0,0,0-24,24V472a8.009,8.009,0,0,0,8,8H472a8.009,8.009,0,0,0,8-8Zm-32,80a8,8,0,0,1-8,8H312a8,8,0,0,1-8-8V376a8,8,0,0,1,8-8H440a8,8,0,0,1,8,8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M408,288h40V272H304v16h72a8,8,0,0,1,0,16H304v16H448V304H408a8,8,0,0,1,0-16Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.36,92.621l125.982,103.75C195.368,190.654,203.811,184,215.878,184H216c22.43,0,40,24.6,40,56,0,27.616-13.588,49.971-32.122,54.959V480h33.5A23.885,23.885,0,0,1,256,472V360a40.068,40.068,0,0,1,32-39.195V264a8,8,0,0,1,8-8h.672a66.078,66.078,0,0,1,3.9-14.971C307.028,224.889,319.61,216,336,216c11.48,0,14.789-2.254,15.678-3.223,1.682-1.833,1.261-6.742.815-11.938-.242-2.828-.493-5.751-.493-8.839a7.977,7.977,0,0,1,7.978-7.988l-.044-15.99q0-.234.012-.465c.03-.553,2.537-56.851-34.84-96.247C300.36,45.226,263.61,32,215.878,32,172.42,32,113.994,37.7,82.447,64.875,69.385,76.125,65.509,87.177,64.36,92.621Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M315.428,246.971a47.9,47.9,0,0,0-2.55,9.029H439.239c-6.294-32.711-50.352-48.261-70.575-53.733.543,7.282.5,15.12-5.2,21.33C358.2,229.33,349.476,232,336,232,326.187,232,319.458,236.9,315.428,246.971Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHair0);
export default __webpack_public_path__ + "static/media/hair0.b860ed127b45cf094aa82e63a4ce8a52.svg";
export { ForwardRef as ReactComponent };